import instance from "./axios";
import baseUrl from "@/env";
// 学生登录
export async function login(data) {
  const res = await instance.post(
    `${baseUrl}/student/login?studentNo=${data.studentNo}&password=${data.password}&collegeid=${data.collegeid}`
  );
  return res.data;
}
//获取登录详情
export async function getStudentDetail() {
  const res = await instance.post(`${baseUrl}/student/detail`);
  return res.data;
}
//s手机号登录
export async function phoneLogin(data) {
  const res = await instance.post(
    `${baseUrl}/student/login?phone=${data.phone}&password=${data.password}`
  );
  return res.data;
}
// 学生注册
export async function register(data) {
  const res = await instance.post(`${baseUrl}/student/studentRegister`, data);
  return res.data;
}
//发送短信
export async function sendCode(data) {
  const res = await instance.get(
    `${baseUrl}/sms/send?phone=${data.phone}&type=${data.type}`
  );
  return res.data;
}
//发送短信
export async function checkCode(data) {
  const res = await instance.get(
    `${baseUrl}/sms/check?code=${data.code}&phone=${data.phone}`
  );
  return res.data;
}
//获取学校地址
export async function getCollegeDetailInfo() {
  console.log("the base url is: " + baseUrl);
  const res = await instance.get(`${baseUrl}/college/getCollegeDetailInfo`);
  return res.data;
}
//获取专业

export async function getMajorByCollegeId(data) {
  // console.log("the base url is: "+baseUrl);
  const res = await instance.get(
    `${baseUrl}/college/getMajorByCollegeId?collegeId=${data.collegeid}`
  );
  return res.data;
}

//发送email验证码
export async function sendEmailCode(address) {
  const res = await instance.get(
    `${baseUrl}/email/sendEmailCode?to=${address}`
  );
  return res.data;
}
